import * as yup from 'yup'

export const campamento = yup.object().shape({
  nombre: yup.string().required('El nombre es obligatorio'),
  siteId: yup.string().required('El site es obligatorio'),
  clienteId: yup.string().required('El cliente es obligatorio'),
  companiaId: yup.string().required('La compañía es obligatorio'),
})
